import React from "react";
import {Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip} from "@material-ui/core";
import moment from "moment/moment";
import VisibilityIcon from '@material-ui/icons/Visibility';
import translate from "../../misc/applyTranslation";
import toValue from "../../misc/serializeToValue";
import Pagination from "../../components/Pagination";
import {connect} from "react-redux";

const InvoicesTable = props => {

  const {classes, batchInvoices, formatNumberWithSpaces, page, totalPages, handlePagination, showInvoiced, access_token} = props;

  const server =window.location.origin;

  const handlePreviewClick = async (invoice_id) => {
    try {
      const response = await fetch(
        `${server}/api/ropo/bill/preview?invoice_id=${invoice_id}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${access_token}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error ${response.status}`);
      }

      // Get PDF as blob
      const blob = await response.blob();

      // Ensure it's actually a PDF
      if (blob.type !== "application/pdf") {
        throw new Error("Response is not a PDF");
      }

      const fileURL = window.URL.createObjectURL(blob);
      window.open(fileURL, "_blank", "noopener,noreferrer");

      // Optional: cleanup after some time
      setTimeout(() => {
        window.URL.revokeObjectURL(fileURL);
      }, 10000);

    } catch (err) {
      console.error("Failed to open PDF preview:", err);
    }
  };


  return (
    <>
      <TableContainer component={Paper} className={classes.container}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>{translate('invoices', 'invoice_latest_table_ocr')}</TableCell>
              <TableCell>{translate('invoices', 'invoice_latest_table_inv_cust_name')}</TableCell>
              <TableCell>{translate('invoices', 'invoice_latest_table_inv_day')}</TableCell>
              <TableCell>{translate('invoices', 'invoie_latest_table_inv_sum')}</TableCell>
              {showInvoiced === 0 && <TableCell>{translate('invoices', 'invoice_latest_table_preview')}</TableCell>}
            </TableRow>
          </TableHead>
          <TableBody>
            {batchInvoices.length > 0 && batchInvoices.map((row) => (
              <TableRow key={row.id} className={!row.downloaded ? classes.bold : ''}>
                <TableCell>{row.ocr}</TableCell>
                <TableCell>{row.inv_cust_name}</TableCell>
                <TableCell>{moment.unix(row.inv_day).format('YYYY-MM-DD')}</TableCell>
                <TableCell>{formatNumberWithSpaces(toValue(row.inv_sum)) + " kr"}</TableCell>
                {showInvoiced === 0 &&
                  <TableCell className={classes.previewCell} onClick={() => handlePreviewClick(row.id)}>
                    <Tooltip title={translate('invoices', 'invoice_latest_table_preview_tooltip')}>
                      <VisibilityIcon/>
                    </Tooltip>
                  </TableCell>
                }
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <div style={{display: 'flex', justifyContent: 'flex-end'}}>
        <Pagination page={page} totalPages={totalPages} onClick={handlePagination}/>
      </div>
    </>
  )
};

const mapStateToProps = store => ({
  access_token: store.login.access_token,
})

export default connect(mapStateToProps)(InvoicesTable);